var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257.36 57.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6a6e77;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.87,31.56h-10.33c-4.96,0-8.99-4.03-8.99-8.99v-13.8h5.08v13.8c0,2.16,1.75,3.91,3.91,3.91h5.25V8.76h5.08v22.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.63,31.6h-5.08v-13.8c0-2.16-1.75-3.91-3.91-3.91h-5.25v17.71h-5.08V8.81h10.33c4.96,0,8.99,4.03,8.99,8.99v13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.4,31.79c-6.39,0-11.58-5.2-11.58-11.58s5.2-11.58,11.58-11.58,11.58,5.2,11.58,11.58-5.2,11.58-11.58,11.58ZM200.4,13.71c-3.58,0-6.5,2.91-6.5,6.5s2.91,6.5,6.5,6.5,6.5-2.91,6.5-6.5-2.92-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.12,31.79c-6.39,0-11.58-5.2-11.58-11.58s5.2-11.58,11.58-11.58,11.58,5.2,11.58,11.58-5.2,11.58-11.58,11.58ZM117.12,13.71c-3.58,0-6.5,2.91-6.5,6.5s2.91,6.5,6.5,6.5,6.5-2.91,6.5-6.5-2.92-6.5-6.5-6.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.94,
    width: 5.35,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 180.28,
    y: 8.57,
    width: 5.35,
    height: 23.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 182.93,
    cy: 3.51,
    r: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.97,13.71v-5.08h-6.67V3.06h-5.08v20.44c0,4.44,3.61,8.05,8.05,8.05h3.7v-5.08h-3.7c-1.64,0-2.97-1.33-2.97-2.97v-9.8h6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.56,31.79h-11.37v-5.08h11.37c.93,0,1.69-.76,1.69-1.69,0-1.05-.88-2.2-1.69-2.2h-4.67c-4.19,0-7.35-2.94-7.35-6.84s3.3-7.35,7.35-7.35h10.74v5.08h-10.74c-1.25,0-2.27,1.02-2.27,2.27,0,1.67,1.89,1.75,2.27,1.75h4.67c3.61,0,6.77,3.41,6.77,7.29s-3.04,6.77-6.77,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.74,31.56h-11.25v-5.08h11.25c1.99,0,4.11-1.01,4.11-2.87,0-1.63-1.1-3.05-2.67-3.47l-7.13-1.77c-3.62-.96-6.12-4.22-6.12-7.92,0-4.51,3.67-8.18,8.18-8.18h12.16v5.08h-12.16c-1.71,0-3.1,1.39-3.1,3.1,0,1.4.95,2.63,2.3,2.99l7.13,1.77c3.84,1.02,6.49,4.47,6.49,8.4,0,4.54-3.95,7.96-9.19,7.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.22,31.64h-7.64c-8.11,0-14.71-6.6-14.71-14.71s6.6-14.71,14.71-14.71h7.64v5.08h-7.64c-5.31,0-9.63,4.32-9.63,9.63s4.32,9.63,9.63,9.63h7.64v5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.6,31.64h-8.33c-8.11,0-14.71-6.6-14.71-14.71s6.6-14.71,14.71-14.71h8.44v5.08h-8.44c-5.31,0-9.63,4.32-9.63,9.63s4.32,9.63,9.63,9.63h3.25v-9.74h5.08v14.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.81,31.56H.56v-5.08h11.25c1.99,0,4.11-1.01,4.11-2.87,0-1.63-1.1-3.06-2.67-3.47l-7.13-1.77c-3.62-.97-6.12-4.22-6.12-7.92C0,5.94,3.67,2.27,8.18,2.27h12.15v5.08h-12.15c-1.71,0-3.1,1.39-3.1,3.1,0,1.4.95,2.63,2.3,2.99l7.13,1.77c3.84,1.02,6.49,4.47,6.49,8.4,0,4.54-3.95,7.96-9.19,7.96Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.32,
    y: 41.32,
    width: 2.67,
    height: 15.89
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47,41.32c-2.87,0-4.78,1.72-4.78,4.88v5.05c0,3.14,1.9,4.84,4.78,4.84s4.82-1.7,4.82-4.84v-5.05c0-3.16-1.9-4.88-4.82-4.88ZM194.69,51.25c0,1.79-.79,2.62-2.23,2.62s-2.21-.83-2.21-2.62v-5.05c0-1.77.79-2.62,2.21-2.62s2.23.85,2.23,2.62v5.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.54 47.33 215.93 47.33 215.93 49.67 218.54 49.67 218.54 57.21 221.22 57.21 221.22 41.32 218.54 41.32 218.54 47.33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.71,
    y: 54.35,
    width: 16.1,
    height: 2.25
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.72 46.66 244.69 46.66 244.69 45.87 256.55 45.87 256.55 41.51 242.1 41.51 242.1 43.32 253.96 43.32 253.96 44.09 242.1 44.09 242.1 48.47 256.72 48.47 256.72 46.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.29 49.19 241.29 51.08 247.94 51.08 247.94 52.24 250.52 52.24 250.52 51.08 257.36 51.08 257.36 49.19 241.29 49.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.98,52.61h-9.31v-.91h-2.57v5.41h14.44v-5.41h-2.57v.91ZM253.98,55.29h-9.31v-.87h9.31v.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.93,
    y: 41.58,
    width: 10,
    height: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.93,
    y: 54.26,
    width: 10,
    height: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.59,
    y: 45.18,
    width: 2.57,
    height: 7.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.71,
    y: 45.18,
    width: 2.57,
    height: 7.72
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.63 52.96 238.32 52.96 238.32 41.51 224.56 41.51 224.56 43.76 235.63 43.76 235.63 52.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "177.41 49.58 177.41 41.68 169.48 41.65 169.48 43.89 174.8 43.92 174.76 47.26 169.48 47.23 169.48 49.45 174.39 49.48 170.12 55.36 172.25 56.78 177.41 49.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.47 47.33 185.26 47.3 185.26 49.64 182.47 49.67 182.47 57.21 179.8 57.21 179.8 41.32 182.47 41.32 182.47 47.33"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmWhite);
export default __webpack_public_path__ + "static/media/logo_sm_white.50d013d24afcf699ea61909532ec2eed.svg";
export { ForwardRef as ReactComponent };